import { findCity, haversineKm } from '@/lib/israelCities';
import { proServesCity, proDistanceKm } from '@/lib/proMatching';
import type { SmartIntakeContext } from '@/components/SmartIntakeBar';

export type ProArea = { lat: number | null; lng: number | null; proCity?: string | null; serviceMode?: string | null; serviceCities?: string | null; serviceRadiusKm?: number | null; nationwide?: boolean };

/** The visitor's city as THIS pro may use it: kept only if the pro serves it (lib/proMatching proServesCity — the same rule
 *  the listing and the pro-page questionnaire use), otherwise dropped so a message never promises a city he does not serve. */
export function ctxForPro<T extends SmartIntakeContext | null>(ctx: T, area?: ProArea | null): T {
  if (!ctx || !area || !ctx.city || area.nationwide) return ctx; // a nationwide category serves every city (bughunter round 3 #6)
  if (area.lat == null || area.lng == null) return ctx;
  const c = findCity(ctx.city); if (!c) return ctx;
  const km = proDistanceKm({ lat: area.lat, lng: area.lng, city: area.proCity ?? null }, c.lat, c.lng); // THE city-anchored km (lib/proMatching)
  return proServesCity({ lat: area.lat, lng: area.lng, serviceMode: area.serviceMode as any, serviceCities: area.serviceCities, serviceRadiusKm: area.serviceRadiusKm } as any, km, c.name)
    ? ctx : ({ ...ctx, city: null, cityLat: null, cityLng: null } as T);
}
